export default __webpack_public_path__ + "static/media/O-142.b52d47fa.png";